import { render, staticRenderFns } from "./EntregaAssociarEvento.vue?vue&type=template&id=677a1608"
import script from "./EntregaAssociarEvento.vue?vue&type=script&lang=js"
export * from "./EntregaAssociarEvento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports